module.exports = __webpack_public_path__ + "img/vator-accessories.6bb7a592.png";